import { Inject, Injectable } from '@angular/core';
import { Referral } from '@models/referral.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DjangoService } from './django.service';
import { LOCALSTORAGE } from './local-storage.service';

@Injectable({
    providedIn: 'root',
})
export class ReferralService {
    constructor(
        private djangoService: DjangoService,
        @Inject(LOCALSTORAGE) private localStorage: Storage
    ) {}

    private readonly REFERRAL_CODE = 'REFERRAL_CODE';

    getReferralCode() {
        return this.localStorage.getItem(this.REFERRAL_CODE);
    }

    storeReferralCode(code: string) {
        this.localStorage.setItem(this.REFERRAL_CODE, code);
    }

    referrals(): Observable<Referral[]> {
        return this.djangoService
            .referrals()
            .pipe(
                map((data: []) =>
                    data.map(referralData =>
                        new Referral().deserialize(referralData)
                    )
                )
            );
    }

    countReferral() {
        const data = {
            referral_code: this.getReferralCode(),
        };
        return this.djangoService.countReferralCode(data);
    }
}
